function OnlineReport() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Report.OnlineReport Visual. <br/>
    /// OnlineReport means you can get a live overview over the selected period in form of a table and a chart
    /// <br/>
    /// Author: MWI<br />
    /// Date: 21.09.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - added titles over icons for interventions and events             *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  

}
OnlineReport.prototype = new window.vcTemplate();

OnlineReport.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
      
        me.showInfo("", "", false);
        me.visual.find("#ddlSignals option:first-child, #ddlYears:last-child").attr("selected", "selected");
        me.visual.find("#ddlSignals, #ddlYears, #ddlselAbsRel").chosen({ "inherit_select_classes": true });
        me.dialogWidth = parseInt($(window).width() * 0.70, 10);
        me.dialogHeight = parseInt($(window).height() * 0.70, 10);

        me.dialog = $("<div>").attr("id", "live-report-info-dialog").css({ display: "none" });

        me.dialog.dialog({ autoOpen: false, modal: true, height: me.dialogHeight, width: me.dialogWidth, closeOnEscape: true, resizable: true, autoresize: false, dialogClass: "saveDialog", buttons: { Ok: function Ok() { $(this).dialog("close"); } } });

        //init vc-calendar

        me.visual.find(".vc-cal").vcDate({ mode: "Single", interval: 3, langID: me.userLangidForCulture, defaultDate: me.sDate, callback: function (obj) { me.sDate = obj.returnDates.from; } });

       me.initClickHandler();
       me.visual.find("#btnShowChartOnline").trigger("click");
       return true;
    } catch (ex) {
        me.writeError("OnlineReport.init", ex);
        return false;
    }
};
OnlineReport.prototype.setReload = function (bLoaded) {
    /// <summary>
    /// sets the large loading button so that it shows the loaded or reloading icon
    /// </summary>
    var me = this;
    try {
        if (bLoaded) {
            me.visual.find("#btnShowChartOnline").html("<i class='fa fa-check'></i><br/>" + me.resources.loaded);
        } else {
            me.visual.find("#btnShowChartOnline").html("<i class='fa fa-sync-alt'></i><br/>" + me.resources.reload);
        }
    } catch (ex) {
        me.writeError("OnlineReport.setReload", ex);
    }
};
OnlineReport.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes the various click handler for the buttons
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".live-report-ddl, .live-report-checkbox").off("change").on("change", function () {
            me.setReload(false);
        });

   
        me.visual.find("#btnShowChartOnline").off("click").on("click", function () {
            try {

                me.setParameterObjects();
                me.parameter.archiveParameter.isReference = me.isReference;
                if (me.visual.find("#ddlYears option:selected").val() >= 6) {
                    me.visual.find("#divOnlineChart").height(me.visual.find("#divOnlineChart").addClass("online-report-side-legend"));
                    me.parameter.archiveParameter.UseSimpleBottomLegend = false;
                      
                }
                me.visual.find("#divOnlineChart, #divOnlineTable").html("");
                window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), JSON.stringify(me.sigPar), me.deviceType, me.langid, "", function(result) { me.btnLoadResult(result);});
                return true;
            } catch (ex1) {
                me.writeError("OnlineReport.btnShowChartOnline", ex1);
                return false;
            }
        });

        return true;
    } catch (ex) {
        me.writeError('OnlineReport.initClickHandler', ex);
        return false;
    }
};
OnlineReport.prototype.btnLoadResult = function (result) {
    /// <summary>
    /// handles the result of the button click and creates the table
    /// </summary>
    var me = this;
    var myTable, body, tmpBody;
    try {
        me.setReload(true);
         myTable = $("<table>").attr("class", "live-report-table");
         body = $("<tbody>").attr("class", "live-report-year-row color-border-secondary");
         if (result.hasError === false) {
             me.showInfo("", "", false);
             me.vcVisual.addVisualContentByName("divOnline", "VISUAL_REPORT_CHART_ONLINE", "Chart", window.getCurrentTimestamp(), me.visual.find("#divOnlineChart").height(), me.visual.find("#divOnlineChart").width(), JSON.stringify(me.parameter.archiveParameter), JSON.stringify(me.sigPar), 1);

            for (var key in result.retHTML) {
                if (result.retHTML.hasOwnProperty(key)) {
                    tmpBody = body.clone();
                    for (var i = 0; i < result.retHTML[key].length; i++) {
                        tmpBody.append(me.createRow(result.retHTML[key][i]));

                    }
                    var colspan = "14";
                    if (me.parameter.archiveParameter.isCumulated) {
                        colspan = "13";
                    }
                    if (key !== "0000") { //key used by me to detect a reference year which basically has no year
                        tmpBody.prepend(
                            "<tr class='live-report-no-cellpadding' ><td class='live-report-year live-report-monthly-sum' rowspan='" +
                            (result.retHTML[key].length + 1) +
                            "'>" +
                            key +
                            "</td><td colspan='" + colspan + "'></td></tr>");
                        tmpBody.attr("data-rowdate", key);
                        tmpBody.prependTo(myTable);
                    } else {
                        tmpBody.prepend(
                            "<tr class='live-report-no-cellpadding' ><td class='live-report-year live-report-monthly-sum' rowspan='" +
                            (result.retHTML[key].length + 1) +
                            "'>&nbsp;</td><td colspan='"+colspan+"'></td></tr>");
                        tmpBody.attr("data-rowdate", key);
                        tmpBody.appendTo(myTable);
                    }
                }
            }
            me.visual.find("#divOnlineTable").html(myTable);
            me.loadNoteCounter(me.ENUM_GET_TYPES["LoadActivityCount"],
                "report-comment-count",
                "fa fa-comment",
                me.loadLists,
                me.resources.activities);
            me.loadNoteCounter(me.ENUM_GET_TYPES["LoadInterventionCount"],
                "report-intervention-count",
                "fa-regular fa-calendar",
                me.loadLists,
                me.resources.interventions);
         } else {
            me.showInfo(result.retHTML, "", false);
        }
    } catch (ex) {
        me.writeError("OnlineReport.btnLoadClick");
        me.error = true;

    }
};
OnlineReport.prototype.createRow = function (rowElement) {
    /// <summary>
    /// helper function that calls the createRows <br/>
    /// that are based on the rowType (e.g. consumption,/temperature,year,reference...)
    /// </summary>
    var me = this;
    var row;
    try {
        switch (rowElement.rowType) {
            case me.ENUM_ROW_TYPES.Consumption:
                row = me.createValueOnlyRowWithMarker(rowElement);
                break;
            case me.ENUM_ROW_TYPES.Temperature:
            case me.ENUM_ROW_TYPES.YearRow:
                row = me.createValueOnlyRow(rowElement);
                break;
            case me.ENUM_ROW_TYPES.Reference:
                row = me.createReferenceRow(rowElement);
                break;
            default:
                row = me.createStandardRow(rowElement);
                break;
        }
        return row;
    } catch (ex) {
        me.writeError("OnlineReportcreateRow", ex);
        return $("<tr class='error>" + me.resources.noEntriesExist + "</tr>");
    }
};
OnlineReport.prototype.createReferenceRow = function (rowElement) {
    /// <summary>
    /// helper function that creates the reference row <br/>
    /// therefore it takes the notes containing the reference date and shows it <br/>
    /// additionally it takes a look at the price parameter and splits the notes if necessary
    /// </summary>
    var me = this;
    var row, cell; //strings but html elements
    var notesSplitted; //array
    var price = "" , title; //strings
    try {
        row = "<tr class='" + me.getRowClass(rowElement.rowType) + "'><td  class='live-report-desc'>" + rowElement.name + "</td>";
        cell = "";
        for (var i = 0; i < rowElement.series.length; i++) {
            if (rowElement.series[i] !== null|| rowElement.notes[i] !== null) {
                notesSplitted = rowElement.notes[i].split(";");
                title = notesSplitted[0];
                if (me.parameter.archiveParameter.usePrices === true) {
                    price = notesSplitted[1];
                    title = notesSplitted[0];
                    } 
                cell += "<td class='color-border-secondary live-report-num' title='" + price + "'>" + rowElement.series[i] + "<br/>" + "<span class='live-report-ref-date'>" + title + "</span></td>";
            } else {
                cell += "<td class='color-border-secondary live-report-num'>-</td>";
            }

        }
        row += cell;
        row += "</tr>";
        return row;
    } catch (ex) {
        me.writeError("OnlineReport.createConsumptionRow", ex);
        return $("<tr class='error>" + me.resources.noEntriesExist + "</tr>");
    }
};
OnlineReport.prototype.createValueOnlyRow = function(rowElement) {
    /// <summary>
    /// helper function that creates a standard rwo with only values <br/>
    /// e.g differences or temperature
    /// </summary>
    ///<remarks>
    ///also called if the rowtype is uknown
    ///</remarks>
    var me = this;
    var row, cell;
    try {
        row = "<tr class='" + me.getRowClass(rowElement.rowType) + "'><td  class='live-report-desc'>" + rowElement.name + "</td>";
        //row = $("<tr>").attr("class", me.getRowClass(rowElement.rowType));
        cell = "";
        for (var i = 0; i < rowElement.series.length; i++) {
            cell += "<td class='color-border-secondary live-report-num'";
            cell += " data-count='" + i + "'"; 
            if (rowElement.notes && rowElement.notes[i]) {
                cell += "title='" + rowElement.notes[i].replace("<span class='icon-color-error'>", "").replace("</span>","") + "'";
            }
            cell +=">" + rowElement.series[i];
               cell += "</td>";

        }
        row += cell;
        row += "</tr>";
        return row;
    } catch (ex) {
        me.writeError("OnlineReport.createConsumptionRow", ex);
        return $("<tr class='error>" + me.resources.noEntriesExist + "</tr>");
    }
};
OnlineReport.prototype.createValueOnlyRowWithMarker = function (rowElement) {
    /// <summary>
    /// helper function that creates a standard rwo with only values <br/>
    /// and markers special for the consumption to show that a value is inplausible/invalid
    /// </summary>
    /// <remarks>
    /// also called if the row type is not known
    ///</remarks>
    var me = this;
    var row, cell;
    try {
        row = "<tr class='" + me.getRowClass(rowElement.rowType) + "'><td  class='live-report-desc'>" + rowElement.name + "</td>";
        cell = "";
        for (var i = 0; i < rowElement.series.length; i++) {
            cell += "<td class='color-border-secondary live-report-num'";
            cell += " data-count='" + i + "'";
            if (rowElement.notes && rowElement.notes[i]) {
                cell += "title='" + rowElement.notes[i].replace("<span class='icon-color-error'>", "").replace("</span>", "") + "'";
            }

            cell += ">";
            if (rowElement.marker[i] && rowElement.marker[i].Valid === false) cell += "<i class='fa-regular fa-times-circle icon-color-error' title='" + me.resources.dataIsInvalid + "'></i> ";
            if (rowElement.marker[i] && rowElement.marker[i].Plausible === false) cell += "<i class='fa-regular fa-exclamation-triangle icon-color-error'  title='" + me.resources.dataIsInPlausible + "'></i> ";
            cell +=      rowElement.series[i];
            cell += "</td>";

        }
        row += cell;
        row += "</tr>";
        return row;
    } catch (ex) {
        me.writeError("OnlineReport.createConsumptionRow", ex);
        return $("<tr class='error>" + me.resources.noEntriesExist + "</tr>");
    }
};
OnlineReport.prototype.createStandardRow = function (rowElement) {
    /// <summary>
    /// helper function that creates a standardRow showing the difference<br/>
   /// </summary>
    /// <remarks>
    /// also called if the row type is not known
    ///</remarks>
    var me = this;
    var row, cell;
    var currVal;
    try {

        row = $("<tr>").attr("class", me.getRowClass(rowElement.rowType));
        cell = "<td class='live-report-desc'>" + rowElement.name + "</td>";
        for (var i = 0; i < rowElement.series.length; i++) {
          currVal = parseFloat(rowElement.series[i]);

            cell += "<td class='color-border-secondary live-report-num";
            if (!isNaN(currVal)) {
                if (currVal > 0) {
                    cell += " live-report-num-negative";
                } else {
                    cell += " live-report-num-positive";
                }

                //rowElement.series[i] = (currVal * -1);
            }
            cell += "'";
            if (rowElement.notes && rowElement.notes[i]) {
                cell += "title='" + rowElement.notes[i] + "'";

            }
            cell += ">" + rowElement.series[i];
            cell += "</td>";
        }
        row.html(cell);
        return row;
    } catch (ex) {
        me.writeError("OnlineReport.createStandardRow", ex);
        return $("<tr class='error>" + me.resources.noEntriesExist + "</tr>");
    }
};
OnlineReport.prototype.getRowClass = function(type) {
    /// <summary>
    /// helper function that returns the row class based on the  row type<br/>
    /// if no matchin type is found an empty class is returned
    /// </summary>
    var me = this;
    var sRet = "";
    try {
        switch (type) {
        case me.ENUM_ROW_TYPES.Consumption:
            sRet = "live-report-monthly-sum";
            break;
        case me.ENUM_ROW_TYPES.Temperature:
            sRet = "live-report-temp";
            break;
        case me.ENUM_ROW_TYPES.AbsoluteDifference:
            sRet = "live-report-abs";
            break;
        case me.ENUM_ROW_TYPES.RelativeDifference:
            sRet = "live-report-percent";
            if (me.parameter.createRows === "2") sRet += " large";
            break;
        case me.ENUM_ROW_TYPES.YearRow:
            sRet = "live-report-year-row table-headers ";
            break;
        case me.ENUM_ROW_TYPES.Reference:
            sRet = "live-report-monthly-sum live-report-ref";
            break;

        default:
            sRet = "";
            break;
        }
    } catch (ex) {
        me.writeError("OnlineReport.getRowClass", ex);

    }
    return sRet;
};


OnlineReport.prototype.loadLists= function (me, sDate, getType) {
    /// <summary>
    /// calls the  Widget based on the type for the given month <br/>
    /// and adds it to the dialog
    /// </summary>
    var date;
    var param, widget,title;
    try {
        if (me.error) {
            return false;
        }
        switch(getType) {
            case me.ENUM_GET_TYPES["LoadActivityCount"]:
                param = "23:59,bdid,false,3,5,false,true,false";
                widget = "WIDGET_ACTIVITY";
                title = me.resources.activities;
                break;
            case  me.ENUM_GET_TYPES["LoadInterventionCount"]:
                param = JSON.stringify({ "interval": 3, "bsaid": me.bsaid });
                widget = "VISUAL_INTERVENTION_LIST";
                title = me.resources.interventions;

                break;
            default:
                return false;
        }
       date = sDate.toString().split(".");
        window.VisualCoreService.getVisualBaseByName(widget, "activities", new Date(date[0], date[1] - 1, 1), me.dialogHeight - 100, me.dialogWidth - 100, param, "", me.deviceType, function (result) {
            me.dialog.dialog("option", "title",   title + " " + $.datepicker.formatDate('MM yy', new Date(date[0], date[1] - 1, 1)));
            me.dialog.html(result).dialog("open");
        });
        return true;
    } catch (ex) {
        me.error = true;
        me.writeError('loadLists', ex);
        return false;
    }
};
OnlineReport.prototype.loadNoteCounter = function (getType, sClass, sIconClass, fnLoad, sTitle) {
    ///<summary>
    ///function that loads the notes (i.e interventionCounter, activitycounter per month)
    ///</summary>
    ///<param name='getType'>the Type to load taken from the array of types</param>
    ///<param name='sClass'>the html-class to use for clickhandler</param>
    ///<param name='sIconClass'>the font-awesome icon to use</param>
    ///<param name='fnLoad'>the callbackFunction that loads the list with activities/notes</param>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.parameter.getParameterType = getType;
        me.visual.find("." + sClass).remove();
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), JSON.stringify(me.sigPar), me.deviceType, me.langid, "", function (result) {
            if (result.retHTML.rows) {
                for (var c = 0; c < result.retHTML.rows.length; c++) {
                    me.visual.find(".live-report-table tbody[data-rowdate='" + result.retHTML.rows[c].year + "'] .live-report-monthly-sum .live-report-num[data-count='" + (result.retHTML.rows[c].month - 1) + "']").prepend("<div class='" + sClass + " report-note-counter' data-date='" + result.retHTML.rows[c].combineddate + "' title='"+ sTitle+"'><i class='"+ sIconClass + "'></i> " + result.retHTML.rows[c].monthsum + "</div>");
                }
                me.visual.find("." + sClass).off("click").on("click", function () {
                    fnLoad(me, $(this).data("date"), getType);
                });
            }
        }
        );
        return true;
    } catch (ex) {
        me.writeError('loadNoteCounter', ex);
        return false;
    }
};

OnlineReport.prototype.setParameterObjects = function() {
    ///<summary>
    ///helper function that prepares the parameter object
    ///</summary>
    var me = this;
    var endDate, endDateStart, compareDateStart, compareDateEnd;
    var withPrices, withTemperature;
    try {
        if (me.error) {
            return false;
        }
        me.parameter = {};
        me.parameter.getParameterType = me.ENUM_GET_TYPES["LoadTable"];
        me.bsaid = me.visual.find("#ddlSignals option:selected").val();
        me.parameter.bsaid = me.bsaid;
        me.parameter.createRows = me.visual.find("#ddlselAbsRel option:selected").val();

      

        endDate = $.datepicker.parseDate('dd.mm.yy', me.sDate);

        endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
        endDateStart = new Date(endDate.getFullYear(), 0, 1);
        if (me.visual.find("#ddlYears option:selected").val() > 1) {
            compareDateStart = $.datepicker.formatDate('dd.mm.yy',
                new Date(endDate.getFullYear() - (me.visual.find("#ddlYears option:selected").val() - 1), 0, 1));
            compareDateEnd = $.datepicker.formatDate('dd.mm.yy', new Date(endDate.getFullYear() - 1, 11, 31));
        } else {
            compareDateStart = "";
            compareDateEnd = "";
        }
        if (me.visual.find("#chbPrice").length > 0) {
            withPrices = me.visual.find("#chbPrice")[0].checked;
        } else {
            withPrices = false;
        }
        if (me.visual.find("#chbTemp").length > 0) {
            withTemperature = me.visual.find("#chbTemp")[0].checked;
        } else {
            withTemperature = false;
        }
        me.parameter.archiveParameter = {
            "LoggerId": me.blid,
            "showLogo": false,
            "isCumulated": me.visual.find("#chbCumulated")[0].checked,
            "usePrices": withPrices,
            "StartingHour": 0,
            "UseSimpleBottomLegend": false,
            "fixTooltip": false,
            "Interval": 5,
            "datatype": 2,
            "FillNullValues": false,
            "ShowIntervention": false,
            "ListHiddenSeries": [],
            "HideSeries": true,
            "ShowInvalidValues": true,
            "NoZoom": false,
            "separateMetAxis": withTemperature,
            "AutoDateUserDefInterval": 0,
            "AutoComparisonInterval": 0,
            "dateUserDef": false,
            "startDate": $.datepicker.formatDate('dd.mm.yy', endDateStart),
            "endDate": $.datepicker.formatDate('dd.mm.yy', endDate),
            "CompareStartDate": compareDateStart,
            "compareEndDate": compareDateEnd,
            "ShowExportIcons": false,
            "ShowPlotLines": true

        };

        me.sigPar = {
            "series":
            [
                {
                    "bsaid": [me.bsaid],
                    "Rule": "[bsaid=" + me.bsaid + "]",
                    "RuleType": 1,
                    "SeriesType": "column"
                }
            ]
          };
        return true;
    } catch (ex) {
        me.writeError('OnlineReport.setParameterObjects', ex);
        return false;
    }
};

OnlineReport.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divOnlineChart, #divOnlineTable").remove();
        }
        return true;
    } catch (ex) {
        me.writeError("OnlineReport.specificInfoHandling", ex);
        return false;
    }
};
//#REGION FILTER
//#END REGION FILTER